import type { AsyncStatus } from 'lib-shared-legacy-types';
import { Action, handleActions } from 'redux-actions';


import { chatFlowsActions } from '../actions/chatFlows';
import type { FlowChatGetGetAllResponseT } from '../api/types';
import type { FlowDataT } from '../containers/powerChatFlow';

export type ChatFlowsStateT = {
  chatFlows: FlowDataT[];
  meta: {
    asyncStatus: AsyncStatus;
  };
};

type ChatFlowsHandleActionPayloadT = FlowChatGetGetAllResponseT;

export const {
  chatFlowsGetAll,
  chatFlowsGetAllSucceeded,
  chatFlowsGetAllFailed,
} = chatFlowsActions;

// Init state for the Chat Flows.
const initialState: ChatFlowsStateT = {
  chatFlows: [],
  meta: {
    asyncStatus: 'succeeded',
  },
};

// Reducer
const chatFlows = handleActions<ChatFlowsStateT, ChatFlowsHandleActionPayloadT>(
  {
    [chatFlowsGetAll.toString()]: (state: ChatFlowsStateT): ChatFlowsStateT => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'loading' } };
    },

    [chatFlowsGetAllSucceeded.toString()]: (
      state: ChatFlowsStateT,
      action: Action<FlowChatGetGetAllResponseT>,
    ): ChatFlowsStateT => {
      const flows: FlowDataT[] =
        action.payload.data &&
        action.payload.data.conversation_flows &&
        Array.isArray(action.payload.data.conversation_flows)
          ? action.payload.data.conversation_flows
          : [];
      return {
        ...state,
        meta: { ...state.meta, asyncStatus: 'succeeded' },
        chatFlows: flows,
      };
    },

    [chatFlowsGetAllFailed.toString()]: (
      state: ChatFlowsStateT,
    ): ChatFlowsStateT => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'failed' } };
    },
  },
  initialState,
);

export default chatFlows;
